import {maxusLogin, getUserInfoV1, bindPopupWindow, login} from '@/api/cust';
import {Decrypt, getLocalCache, setLocalCache, setLocalCacheObj} from '@/assets/js/common'
import {Toast   } from 'vant'

const mixin= {
  components: {
    [Toast .name]: Toast ,
  },
  data() {
    return {
      isShowCust: true,
      flag: 0,
      disX: 0,
      disY: 0,
      starX: 0,
      starY: 0,
      CUST_BASE_URL: '',
      BASE_SSO: ''
    };
  },
  created() {
    this.init()
    switch(window.env) {
      case 'dev': 
      case 'sit': 
      case 'uat':
        this.CUST_BASE_URL = 'https://test102.maxuscloud.cn/'
        this.BASE_SSO = 'https://c2bt4.maxuscloud.com/sso/authorize?response_type=code&scope=read&client_id=bdbba470434a432488e5d3350bc3239f&redirect_uri='
        break
      default:
        this.CUST_BASE_URL = 'https://imcc.saicmaxus.com/'
        this.BASE_SSO = 'https://c2bapi02-cv.saicmotor.com/sso/authorize?response_type=code&scope=read&client_id=825e811da2844ff1bf29067b408b4270&redirect_uri='
    }
  },
  methods: {
    isZUZU() {
      var userAgent = window.navigator.userAgent;
      return userAgent.indexOf('ZZCIOS') !=-1 || userAgent.indexOf('ZZCAndroid') !=-1;
    },
    init() {
      if(window.wehotelSDK){
        (function(WeSDK){
          // 设置appKey
          WeSDK.setAppKey('95b04967d08c42ad91b1d56ad7e7536a');
          WeSDK.ready(function(){
            // 调用方法
          })
        })(window.wehotelSDK);
      }
      // 如果是maxus 或者  游上海  则不展示客服
      if (window.navigator.userAgent.toLowerCase().indexOf("/maxuslife/")!==-1 || this.isSHANGHAI()){
        this.isShowCust = false
      }
      // if (getLocalCache('encryptedMobile')) {} else {
      //   this.getUserInfos()
      // }
    },
    // 客服拖动
    touchstart(e) {
      this.flag = 0;
      let offsetLeft = this.$refs.cust.offsetLeft
      let offsetTop = this.$refs.cust.offsetTop
      e.preventDefault();//阻止触摸时页面的滚动，缩放
      this.disX = e.touches[0].clientX - offsetLeft;
      this.disY = e.touches[0].clientY - offsetTop;
      //手指按下时的坐标
      this.starX = e.touches[0].clientX;
      this.starY = e.touches[0].clientY;
    },
    touchmove(e) {
      this.flag = 1;
      let offsetWidth = this.$refs.cust.offsetWidth
      let offsetHeight = this.$refs.cust.offsetHeight
      let L = e.touches[0].clientX - this.disX;
      let T = e.touches[0].clientY - this.disY;
      //移动时 当前位置与起始位置之间的差值
      // this.starXEnd = e.touches[0].clientX - this.starX;
      // this.starYEnd = e.touches[0].clientY - this.starY;
      if(L < 0){//限制拖拽的X范围，不能拖出屏幕
        L = 0;
      }else if(L > document.documentElement.clientWidth - offsetWidth){
        L = document.documentElement.clientWidth - offsetWidth;
      }
      if(T < 0){//限制拖拽的Y范围，不能拖出屏幕
        T = 0;
      }else if(T > document.documentElement.clientHeight - offsetHeight){
        T = document.documentElement.clientHeight - offsetHeight;
      }
      let moveX = L + 'px';
      let moveY = T + 'px';
      this.$refs.cust.style.left = moveX;
      this.$refs.cust.style.top = moveY;
    },
    touchend() {
      // 点击
      if(this.flag === 0) {
        this.gotoCust()
      }
    },
    // url params
    getUrlData() {
      let url = window.location.href, urlstr = url.split('?')[1];
      if (urlstr) {
        urlstr = urlstr.split('#')[0];
        let urlarr = urlstr.split('&'), data = {};
        for(let i = 0; i < urlarr.length; i++) {
          let cur = urlarr[i]
          let arr = (cur + '').split('=');
          data[arr[0]] = arr[1];
        }
        return data;
      }
      else {
        return false;
      }
    },
    getUserInfos() {
      getUserInfoV1().then(json2 => {
        if(json2.code == '0042001' || json2.code == '0042002'){
          setLocalCache('encryptedMobile','');
        } else {
          if (json2.statusCode == "0"){
            let data = json2.resultData;
            setLocalCache('encryptedMobile', (!json2.resultData.encryptedMobile ?'':json2.resultData.encryptedMobile));
            setLocalCache('webUserId', (!json2.resultData.id ? '' : json2.resultData.id));
            //user-token
            // //loginName
            setLocalCache('phoneNum', (!data.mobile ? '' :  Decrypt(data.mobile)));
            // //displayName,用户名
            setLocalCache('realName', (!data.realName ? '' :  Decrypt(data.realName)));
            // //userid
            setLocalCache('loginName', (!data.loginName ? '' : Decrypt(data.loginName)));
            // setLocalCache('wxOpenId', (!data.wechatOpenid ? '' : data.wechatOpenid));
            // setLocalCache('TOKEN', (!data.wechatOpenid ? '' : data.wechatOpenid));
            setLocalCache('idNo', (!data.idCode ? '' : data.idCode));
            setLocalCache('userBirth', (!data.userBirth ? '' : data.userBirth));
            setLocalCache('saicCode', (!data.saicCode ? '' : data.saicCode));
            setLocalCache('userUuid', (!data.userUuid ? '' : data.userUuid));
            setLocalCache('userMobile', (!data.mobile ? '' :  Decrypt(data.mobile)));
          } else{
            Toast({
              message: json2.message,
              duration: 2000
            });
          }
        }
      })
    },
    isSHANGHAI() {
      let userAgent = window.navigator.userAgent;
      return userAgent.indexOf('BGSH_CHINA') !=-1 || userAgent.indexOf('BGSH_OVERSEA') !=-1;
    },
    // 登录callLogin
    callLogin(popupId) {
      let _userAgent = window.navigator.userAgent;
      if (_userAgent.toLowerCase().indexOf("/maxuslife/")!==-1) {
        if (!!this.getUrlData().code) {
          this.maxusLogin(popupId);
        } else {
          window.location.href = this.BASE_SSO + encodeURIComponent(location.href) +'&state=a5fd852f-c120-4ba1-89d0-d66dd3582bc9';
        }
      } else if (this.isSHANGHAI()) {
        this.SDKLogin();
      } else {
        let rent = window.env == 'prd' ? 'rent' : 'rv-rental-h5-web'
        if (popupId) {
          location.href = `https://${location.host}/${rent}/login.html?channel=${popupId}`
        }else{
          window.location.href = `https://${location.host}/${rent}/login.html`
        }
      }
    },
    // maxus login
    maxusLogin(popupId) {
      let maxusLoginParams = {
        maxusSSOCode: this.getUrlData().code,
        ssoRedirectUri: location.href.indexOf("?code=")!=-1?location.href.split("?code=")[0]:location.href.indexOf("&code=")!=-1?location.href.split("&code=")[0]:location.href,
        userSource: 86010004,
        loginChannelSource: 53,
        userAgreement: 1
      };
      maxusLogin(maxusLoginParams).then(json => {
        if (json.code == "0000"){
          let data = json.data;
          let phoneNum = data.mobile;
          // //loginName
          setLocalCache('phoneNum', (!data.mobile ? '' : Decrypt(data.mobile)));
          // //userid
          setLocalCache('webUserId', (!data.id ? '' : data.id));
          setLocalCache('loginName', (!data.loginName ? '' : Decrypt(data.loginName)));
          setLocalCache('idNo', (!data.idCode ? '' : data.idCode));
          setLocalCache('encryptedMobile', (!data.encryptedMobile ? '' : data.encryptedMobile));
          let userInfo = {...data};
          userInfo.driverIdCode =  Decrypt(userInfo.driverIdCode);
          userInfo.driverMobile =  Decrypt(userInfo.driverMobile);
          userInfo.driverRealName =  Decrypt(userInfo.driverRealName);
          userInfo.loginName = Decrypt(userInfo.loginName);
          userInfo.mobile = Decrypt(userInfo.mobile);
          userInfo.realName = Decrypt(userInfo.realName);
          setLocalCacheObj('userInfo', userInfo);
          this.getUserInfos()
          window.location.reload();
          bindPopupWindow({
            deviceSourceType:"88030004",
            id: popupId,
            isNeedSync: 0,
            finalIndex: getLocalCache('finalIndex') - 0,
          }).then(res => {})
        }
      })
    },
    SDKLogin() {
      wehotelSDK.login({
        data: {
          forceLogin: false
          // 入参数
        },
        success: (data) => {
          // 返回值
          if (data.message) {
            let mobile = data.result.member.mobile;
            this.autoLogin(mobile)
          }
        }
      })
    },
    autoLogin(phone) {
      let memberPhone = phone;
      accessTokenLogin({
        clientId: "u2fsdgvkx200h9i5z7ewll5bkm99nh3g",
        clientSecret: "olega10z6519b6heridstseub0rdfs4o",
        grantType: "client_credentials"
      }).then(json => {
        if (json.code === "0") {
          let autoLoginParams ={
            phone: memberPhone,
            timestamp: new Date().getTime(),
            loginPlatformSource: 2001,  
            signature: "b5119c7c96d7be408954fcbb31e765e0c5d9d796ad1fc56ac7f08b4ee3425f7c",
            access_token: json.data.accessToken
          }
          login(autoLoginParams).then(res => {
            location.reload();
          })
        }
      })
    },
    gotoCust() {
      if (getLocalCache('encryptedMobile')){
        // window.location.href = "https://test102.maxuscloud.cn/imWeb/fangche/loading.html?codeKey=27&encryptMobile="+window.encodeURIComponent(getLocalCache('encryptedMobile'));
        if (this.isZUZU()) {
          window.location.href = this.CUST_BASE_URL + "imfangche/loading.html?codeKey=33&encryptMobile="+getLocalCache('encryptedMobile')+"&ZZCAppArg=wholepageselfopen";
        } else{
          window.location.href = this.CUST_BASE_URL + "imfangche/loading.html?codeKey=33&encryptMobile="+getLocalCache('encryptedMobile');
        }
        window.location.href = this.CUST_BASE_URL + "imfangche/loading.html?codeKey=33&encryptMobile="+getLocalCache('encryptedMobile');
      } else {
        this.callLogin();
        // window.location.href = "./login.html"
      }
    },
  },
};

export default mixin;


// WEBPACK FOOTER //
// ./src/mixins/cust.js